import React, { useEffect } from 'react'
import s from './PricingTable.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'
import sAnim from 'components/Animation/Animation.scss'
import Button from 'components/Button'
import Tick from 'components/Icons/Tick'
import { Row, Col } from 'components/Layout'

export default props => {
  const { details = [], signupModal, showRatesModal, location } = props

  // if _aof query param is set we have to open signup form immediately after render
  const autoOpen = location.query['_aof']
  if (autoOpen) {
    details.some(item => {
      if (item.productGroup && item.id === autoOpen) {
        useEffect(() => {
          signupModal({ productGroup: item.productGroup, productId: item.id })
        })

        return true
      }
    })
  }

  return (
    <Row className={cn(s.row, sLay['layout-gt-xs-row'])}>
      {details.map((item, idx) => (
        <Col key={idx} className={cn(s.pricingTable, sLay['layout-column'], sLay.flex)}>
          <div
            className={cn(s.inner, sLay['layout-column'], sLay.flex, {
              [s.recommended]: item.recommended,
            })}
          >
            <div className={s.name}>{item.name}</div>

            <div className={s.descriptions}>{item.descriptions[0]}</div>

            <div className={s.price}>{item.price}</div>

            <div className={s.features}>
              <div className={cn(sLay['layout-row'], sLay['layout-align-start-center'])}>
                <div className={cn(s.feature, sLay.flex)}>{item.features[0]}</div>
              </div>
            </div>

            <div
              className={cn(s.button, sLay['layout-column'], sLay['layout-align-center-center'])}
            >
              {item.productGroup ? (
                <Button
                  className={cn(sAnim.pulse, s.buttonChoose)}
                  color="tertiary"
                  rect
                  onClick={() =>
                    signupModal({ productGroup: item.productGroup, productId: item.id })
                  }
                >
                  {item.productGroup === 'product1300Plans' ||
                  item.productGroup === 'product1800Plans'
                    ? 'Start your free trial'
                    : 'Choose'}
                </Button>
              ) : (
                <Button
                  className={cn(sAnim.pulse, s.buttonCall)}
                  color="tertiary"
                  rect
                  href="tel:+611300688588"
                >
                  Call: 1300 688 588
                </Button>
              )}
            </div>

            <div className={s.features}>
              {item.features.slice(1).map((feature, fIdx) => (
                <div
                  key={fIdx}
                  className={cn(sLay['layout-row'], sLay['layout-align-start-center'])}
                >
                  <Tick size={20} />
                  <div className={cn(s.feature, sLay.flex)}>{feature}</div>
                </div>
              ))}
            </div>
            <div className={s.descriptions}>
              {item.descriptions.slice(1).map((descrip, dIdx) => (
                <div key={dIdx}>{descrip}</div>
              ))}
            </div>
            <div className={sLay.flex} />
            <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}>
              {item.rates && (
                <Button
                  style={{ marginTop: '20px' }}
                  onClick={() => showRatesModal({ rates: item.rates })}
                  size="sm"
                  next
                >
                  See what else is available
                </Button>
              )}
              {item.cis && (
                <a
                  style={{ marginTop: '10px', fontSize: '10px' }}
                  size="xs"
                  href={item.cis}
                  target="_blank"
                  rel="noopener noreferrer"
                  download={`Pickle-CIS-${item.name}`}
                  className={s.cis}
                >
                  Critical Information Summary
                </a>
              )}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/PricingTable/PricingTable.jsx